const options = {
  rootMargin: "800px 0px 0px"
};

const io = new IntersectionObserver(ioCallback, options);

function ioCallback(entries, io) {
  entries.forEach((entry) => {
    const {target, isIntersecting} = entry;

    // General lazy loading image and video
    switch (target.tagName) {
      case 'IMG': {
        if (isIntersecting) {
          if (Modernizr.touchevents && target.dataset.isHoverImage) {
            io.unobserve(target);
          } else {
            io.unobserve(target);
            target.src = target.dataset.src;
            target.removeAttribute('defer');
          }
        }
        break;
      }
      case 'VIDEO': {
        if (isIntersecting && target.classList.contains('autoplay')) {
          target.play();
        } else {
          target.pause();
        }
        break;
      }
    }

    // Product page fixed header
    switch (target.classList[0]) {
      case 'add-to-cart-form': {
        const productAddToCartFormHeaderEl = document.querySelector(
          '#product-add-to-cart-form-header',
        );

        if (isIntersecting) {
          productAddToCartFormHeaderEl.classList.remove('active');
        } else {
          productAddToCartFormHeaderEl.classList.add('active');
        }
      }

      // case 'subcollection__intersection__helper': {
      //   const secondaryMenuEl = document.querySelector('#secondary-menu');
      //   const {childIndex, accentColor, handle} = target.dataset;

      //   if (isIntersecting) {
      //     secondaryMenuEl.children[childIndex].classList.add('active');
      //     secondaryMenuEl.classList.add(handle);
      //   } else {
      //     secondaryMenuEl.children[childIndex].classList.remove('active');
      //     secondaryMenuEl.classList.remove(handle);
      //   }
      // }
    }
  });
}

export default io;
